import React from "react";
import CustomPageRendererOverview from "../../Components/CustomPageComponents/CustomPageRendererOverview";

const CustomPageRenderedPage = (props) => {
  return (
    <div>
      <CustomPageRendererOverview params={props.match.params} />
    </div>
  );
};

export default CustomPageRenderedPage;
